// Quiz "Produto Ideal" (sections/quiz-produto-ideal.liquid).
// Cuida da etapa de ocasião (1), das 4 perguntas (2) e da pontuação. A tela de resultado (cards +
// barra "Finalize sua compra") é a mesma do Escolha por Ocasião e é
// renderizada pelo global.js (paraVoce*): este arquivo coloca
// ?ocasiao=quiz-produto&resposta=N na URL e dispara um popstate, que o
// global.js já trata abrindo a etapa 3 com data-op-data["quiz-produto"].answers[N].
// Delegação no document, sem <script> inline (ver comentário do occasion-picker).
(function () {
  var SLUG = 'quiz-produto';
  var CHEVRON_SVG =
    '<svg class="icon icon-caret" viewBox="0 0 10 6"><path fill="currentColor" fill-rule="evenodd" d="M9.354.646a.5.5 0 0 0-.708 0L5 4.293 1.354.646a.5.5 0 0 0-.708.708l4 4a.5.5 0 0 0 .708 0l4-4a.5.5 0 0 0 0-.708" clip-rule="evenodd"/></svg>';

  var occasion = null;
  var answers = [];
  var dispatching = false;

  function getApp() {
    return document.querySelector('[data-qp-app]');
  }

  function getQuiz() {
    var el = document.querySelector('[data-qp-quiz]');
    if (!el) return null;
    try {
      return JSON.parse(el.textContent);
    } catch (e) {
      return null;
    }
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  function setProgress(app, pct) {
    var fill = app.querySelector('[data-op-progress]');
    var dot = app.querySelector('[data-op-progress-dot]');
    if (fill) fill.style.width = pct + '%';
    if (dot) dot.style.left = pct + '%';
  }

  function setNav(app, show) {
    var prev = app.querySelector('[data-qp-prev]');
    var reset = app.querySelector('[data-qp-reset]');
    if (prev) prev.hidden = !show;
    if (reset) reset.hidden = !show;
  }

  function clearResultParams() {
    var url = new URL(window.location.href);
    if (!url.searchParams.has('resposta')) return;
    url.searchParams.delete('ocasiao');
    url.searchParams.delete('resposta');
    window.history.replaceState({}, '', url);
  }

  // Ocasião + perguntas + resultado = marcas na barra
  function totalMarks(quiz) {
    return quiz.questions.length + 2;
  }

  function showStep(app, which) {
    ['1', '2', '3'].forEach(function (n) {
      var el = app.querySelector('[data-op-step="' + n + '"]');
      if (el) el.hidden = n !== which;
    });
    var bar = app.querySelector('[data-op-bundle-bar]');
    if (bar && which !== '3') bar.hidden = true;
  }

  function renderOccasion(app) {
    var quiz = getQuiz();
    if (!quiz) return;
    showStep(app, '1');
    app.querySelectorAll('[data-qp-occasion]').forEach(function (card) {
      card.classList.toggle('is-selected', card.getAttribute('data-qp-occasion') === occasion);
    });
    setProgress(app, Math.round((1 / totalMarks(quiz)) * 100));
    setNav(app, false);
  }

  function renderQuestion(app, index) {
    var quiz = getQuiz();
    if (!quiz) return;
    if (!occasion) {
      renderOccasion(app);
      return;
    }
    var total = quiz.questions.length + 1;
    var q = quiz.questions[index];

    showStep(app, '2');

    app.querySelector('[data-qp-counter]').textContent = (index + 2) + ' de ' + total;
    app.querySelector('[data-qp-question]').textContent = q.question;

    var grid = app.querySelector('[data-qp-answers]');
    grid.innerHTML = '';
    q.answers.forEach(function (answer, i) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'occasion-picker__card qp-answer' + (answers[index] === i ? ' is-selected' : '');
      btn.setAttribute('data-qp-answer', i);
      btn.innerHTML =
        '<div class="occasion-picker__info">' +
          '<div class="occasion-picker__text">' +
            '<p class="occasion-picker__title">' + escapeHtml(answer.label) + '</p>' +
          '</div>' +
          '<span class="occasion-picker__chevron">' + CHEVRON_SVG + '</span>' +
        '</div>';
      grid.appendChild(btn);
    });

    setProgress(app, Math.round(((index + 2) / totalMarks(quiz)) * 100));
    setNav(app, true);
  }

  function computeResult(quiz) {
    var scores = {};
    Object.keys(quiz.start).forEach(function (k) { scores[k] = quiz.start[k]; });
    // Ocasião (1ª etapa) vale 2020/1010 (desempate), as perguntas 2000/1000 — igual ao quiz do ManyChat
    var o = quiz.occasions[occasion];
    if (o) {
      scores[o.primary] += 2020;
      scores[o.secondary] += 1010;
    }
    answers.forEach(function (choice, qi) {
      var a = quiz.questions[qi].answers[choice];
      scores[a.primary] += 2000;
      scores[a.secondary] += 1000;
    });
    var best = quiz.results[0];
    quiz.results.forEach(function (k) {
      if (scores[k] > scores[best]) best = k;
    });
    return quiz.results.indexOf(best);
  }

  // Ajustes visuais depois que o global.js monta a etapa 3
  function decorateResult(app, resultIndex) {
    var quiz = getQuiz();
    if (!quiz) return;
    var key = quiz.results[resultIndex];
    var nameEl = app.querySelector('[data-qp-result-name]');
    if (nameEl) nameEl.textContent = (quiz.names[key] || '') + '.';

    // Selo do card principal vem do Escolha por Ocasião ("Combina com a ocasião")
    app.querySelectorAll('.op-rec__check').forEach(function (check) {
      check.childNodes.forEach(function (node) {
        if (node.nodeType === 3 && node.textContent.indexOf('ocasião') !== -1) {
          node.textContent = 'Combina com suas respostas';
        }
      });
    });

    setNav(app, true);
    setProgress(app, 100);
  }

  function showResult(app, resultIndex) {
    var url = new URL(window.location.href);
    url.searchParams.set('ocasiao', SLUG);
    url.searchParams.set('resposta', resultIndex);
    window.history.pushState({ ocasiao: SLUG, resposta: resultIndex }, '', url);

    dispatching = true;
    window.dispatchEvent(new PopStateEvent('popstate', { state: { ocasiao: SLUG, resposta: resultIndex } }));
    dispatching = false;

    decorateResult(app, resultIndex);
  }

  function currentResultFromUrl() {
    var params = new URLSearchParams(window.location.search);
    if (params.get('ocasiao') !== SLUG || params.get('resposta') === null) return null;
    var n = parseInt(params.get('resposta'), 10);
    return isNaN(n) ? null : n;
  }

  document.addEventListener('click', function (e) {
    var app = getApp();
    if (!app || !e.target.closest) return;

    var occasionBtn = e.target.closest('[data-qp-occasion]');
    if (occasionBtn && app.contains(occasionBtn)) {
      var slug = occasionBtn.getAttribute('data-qp-occasion');
      // Trocou de ocasião: as respostas anteriores não valem mais
      if (slug !== occasion) answers = [];
      occasion = slug;
      renderQuestion(app, Math.min(answers.length, (getQuiz() || { questions: [0] }).questions.length - 1));
      app.scrollIntoView({ behavior: 'smooth', block: 'start' });
      return;
    }

    var answerBtn = e.target.closest('[data-qp-answer]');
    if (answerBtn && app.contains(answerBtn)) {
      var quiz = getQuiz();
      if (!quiz) return;
      var index = Math.min(answers.length, quiz.questions.length - 1);
      // Se voltou e respondeu de novo, descarta as respostas seguintes
      answers = answers.slice(0, index);
      answers[index] = parseInt(answerBtn.getAttribute('data-qp-answer'), 10);
      if (answers.length < quiz.questions.length) {
        renderQuestion(app, answers.length);
        app.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } else {
        showResult(app, computeResult(quiz));
      }
      return;
    }

    if (e.target.closest('[data-qp-prev]')) {
      var onResult = !app.querySelector('[data-op-step="3"]').hidden;
      clearResultParams();
      if (onResult) {
        // Volta pra última pergunta (com a resposta marcada); sem histórico (página aberta já no resultado), recomeça
        if (answers.length) {
          answers = answers.slice(0, answers.length - 1);
          renderQuestion(app, answers.length);
        } else {
          occasion = null;
          renderOccasion(app);
        }
      } else if (answers.length === 0) {
        // Na 1ª pergunta: volta pra escolha da ocasião (com ela marcada)
        renderOccasion(app);
      } else {
        answers = answers.slice(0, answers.length - 1);
        renderQuestion(app, answers.length);
      }
      return;
    }

    if (e.target.closest('[data-qp-reset]')) {
      occasion = null;
      answers = [];
      clearResultParams();
      renderOccasion(app);
      app.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }
  });

  // Roda depois do listener do global.js (este script carrega depois)
  window.addEventListener('popstate', function () {
    if (dispatching) return;
    var app = getApp();
    if (!app) return;
    var result = currentResultFromUrl();
    if (result !== null) {
      decorateResult(app, result);
    } else {
      var quiz = getQuiz();
      var index = quiz ? Math.min(answers.length, quiz.questions.length - 1) : 0;
      if (answers.length >= (quiz ? quiz.questions.length : 4)) answers = answers.slice(0, index);
      renderQuestion(app, index);
    }
  });

  function init() {
    var app = getApp();
    if (!app) return;
    var result = currentResultFromUrl();
    if (result !== null) {
      // Página aberta direto no resultado: o global.js já renderizou a etapa 3 no DOMContentLoaded
      if (!app.querySelector('[data-op-step="3"]').hidden) {
        decorateResult(app, result);
        return;
      }
      clearResultParams();
    }
    renderOccasion(app);
  }

  // Script com defer roda ANTES do DOMContentLoaded; o global.js também usa
  // DOMContentLoaded (abre o resultado vindo da URL e reseta a barra), então
  // o init precisa vir depois dele, senão um sobrescreve o outro.
  if (document.readyState === 'complete') {
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
